module.exports = __webpack_public_path__ + "img/6.0351b620.png";